import { render, staticRenderFns } from "./performTsks.vue?vue&type=template&id=044fdb20&scoped=true&"
import script from "./performTsks.vue?vue&type=script&lang=js&"
export * from "./performTsks.vue?vue&type=script&lang=js&"
import style0 from "./performTsks.vue?vue&type=style&index=0&id=044fdb20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044fdb20",
  null
  
)

export default component.exports